import {UrlBuilder} from "../../../../common/utils/url";
import {html, type TemplateResult} from "lit";
import {customElement, property, query} from "lit/decorators.js";
import {SEARCH_QUERY_PARAMETER_NAME} from "../constants";
import {UnLitElement} from "../../../../common/elements";
import {trackingTextlinkInteract} from "../../../../tracking/trackingAttributes";

@customElement("eop-news-search-preview-tile-tag")
export class EopNewsSearchPreviewTileTag extends UnLitElement {

    @property()
    private url: string;
    @property()
    private text: string;

    @query("a")
    private linkElement: HTMLElement;

    public render(): TemplateResult {
        const url = this.getTargetUrl();

        return html`
            <div class="tag-container reverse-background">
                <a href=${url} class="tag" ${trackingTextlinkInteract(this.text, url)} @keydown=${this.preventTriggeringParentTile}>${this.text}</a>
            </div>
        `;
    }

    private preventTriggeringParentTile(event: KeyboardEvent): void {
        event.stopPropagation();
    }

    private getTargetUrl(): string {
        return new UrlBuilder(this.url)
            .withQueryParameter(SEARCH_QUERY_PARAMETER_NAME, this.text)
            .build();
    }

    public focusableElement(): HTMLElement {
        return this.linkElement;
    }
}